import { Link } from "@chakra-ui/react";
import { PropsWithChildren } from "react";

const helpLink = (article: string) =>
  `https://help.avela.org/hc/en-us/articles/${article}`;

export function LearnMore({
  article,
  children = "Learn more",
}: PropsWithChildren<{ article: string }>) {
  return (
    <Link
      href={helpLink(article)}
      isExternal
      color="primary.500"
      textDecoration="underline"
    >
      {children}
    </Link>
  );
}
